import { render, staticRenderFns } from "./menuTab.vue?vue&type=template&id=773afb2e&scoped=true&"
import script from "./menuTab.vue?vue&type=script&lang=js&"
export * from "./menuTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773afb2e",
  null
  
)

export default component.exports